import React from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import EmersonHeader from "../components/header/EmersonHeader";
import FooterTwo from "../components/footer/FooterTwo";
import { useService } from "../services/servicesService";

function ServiceDetail() {
  const { slug } = useParams();
  const { data: service, isLoading: loading } = useService(slug);

  if (loading) {
    return (
      <div>
        <EmersonHeader />
        <div className="container text-center py-5">
          <p>Loading service...</p>
        </div>
        <FooterTwo />
      </div>
    );
  }

  if (!service) {
    return (
      <div>
        <EmersonHeader />
        <div className="container text-center py-5">
          <h2>Service Not Found</h2>
          <Link to="/" className="rts-btn btn-primary">
            Back to Home
          </Link>
        </div>
        <FooterTwo />
      </div>
    );
  }

  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Services", link: "#" },
    { label: service.name },
  ];

  const processSteps = [
    {
      title: "Discovery & Scope",
      desc: "Requirement capture, feasibility, design intent definition.",
      step: "01",
    },
    {
      title: "Engineering & Realisation",
      desc: "Detailed design, documentation, procurement, fabrication.",
      step: "02",
    },
    {
      title: "Integration & Validation",
      desc: "Assembly, QA/QC, FAT, digital twin validation and documentation.",
      step: "03",
    },
    {
      title: "Deployment & Support",
      desc: "SAT, training, handover, AMC onboarding and lifecycle governance.",
      step: "04",
    },
  ];

  console.log(service);

  return (
    <div className="service-detail-page">
      <EmersonHeader />
      <Breadcrumb
        title={service.name}
        breadcrumbs={breadcrumbs}
        breadcrumbBg={
          service.image ? service.image : "/assets/images/breadcrumb/01.jpg"
        }
      />

      <section className="service-detail-hero rts-section-gap">
        <div className="container">
          <div className="service-detail-hero-card">
            <span className="service-detail-tagline">{service.tagline}</span>
            <h1 className="service-detail-title">{service.name}</h1>
            <p className="service-detail-description">{service.description}</p>
            {/* <div className="service-hero-meta">
                            <div className="service-hero-meta-item">
                                <span>Engagements Delivered</span>
                                <strong>120+</strong>
                            </div>
                            <div className="service-hero-meta-item">
                                <span>Industries Served</span>
                                <strong>08</strong>
                            </div>
                            <div className="service-hero-meta-item">
                                <span>Avg. Project Span</span>
                                <strong>16 Weeks</strong>
                            </div>
                        </div> */}
          </div>
        </div>
      </section>

      <section className="service-detail-body">
        <div className="container">
          <div className="row g-5 align-items-start service-detail">
            <div className="col-lg-7 ">
              <div
                className="service-detail-content"
                dangerouslySetInnerHTML={{
                  __html: service.other_details_html,
                }}
              />
            </div>
            <div className="col-lg-5">
              <div className="service-detail-insight-card">
                <h4 className="insight-title">Why Partner with Sembian?</h4>
                <ul className="insight-list">
                  <li>Multidisciplinary engineering expertise</li>
                  <li>Compliance-ready documentation</li>
                  <li>Global project delivery experience</li>
                  <li>Lifecycle support and AMC readiness</li>
                </ul>
                <div className="insight-cta">
                  <Link className="rts-btn btn-primary" to="/contactus">
                    Talk to Our Team
                  </Link>
                </div>
                <div className="insight-contact-block">
                  <span>Prefer a quick call?</span>
                  <a href="tel:+91-422-23419872">
                    <i className="fas fa-phone-alt"></i> +91-422-23419872
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-process rts-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="service-process-head">
                <span className="process-tag">DELIVERY FRAMEWORK</span>
                <h3>Structured Engagement, Predictable Outcomes</h3>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {processSteps.map((step, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className="service-process-card">
                  <div className="step-count">{step.step}</div>
                  <h5>{step.title}</h5>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-cta ">
        <div className="container">
          <div className="service-detail-cta-card minimal">
            <p>
              <h3 style={{ color: "#ffffff" }}>
                From concept to commissioning — engineered excellence delivered.
              </h3>
              <span style={{ fontSize: "20px", color: "#fefefe" }}>
                Partner with Sembian for complete engineering services,
                technical consultancy, training, and inspection support built on
                global experience and multidisciplinary expertise.
              </span>
            </p>
            <Link className="rts-btn btn-white minimal" to="/contactus">
              Start a Project
            </Link>
          </div>
        </div>
      </section>

      <FooterTwo />
    </div>
  );
}

export default ServiceDetail;
